/**
 * trafficSource — atribuire sursă de trafic pe durata sesiunii.
 *
 * Captează parametrii UTM de la prima aterizare (ex. link din articol de presă)
 * și îi păstrează în sessionStorage, ca să fie disponibili la înregistrare
 * (trackEvent 'sign_up') chiar dacă userul navighează prin site între timp.
 *
 * Traficul de presă (utm_medium=press sau utm_source dintr-o publicație) este
 * tratat special: pe el NU afișăm gimmick-uri de urgență (exit-intent popup,
 * beta countdown) — cititorii veniți dintr-un articol sunt cel mai sceptic
 * segment și pattern-urile astea le distrug încrederea.
 */

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const STORAGE_KEY = 'pb_utm';

// utm_source-uri considerate presă chiar fără utm_medium=press.
const PRESS_SOURCES = ['press', 'zf', 'ziarulfinanciar', 'iqads', 'adplayers', 'profit', 'economedia', 'forbes', 'biziday'];

/**
 * Citește UTM-urile din URL-ul curent și le salvează în sessionStorage.
 * First-touch: nu suprascrie o atribuire deja salvată în sesiunea curentă.
 * Idempotent și safe în afara browserului (SSR/teste).
 */
export function captureUtmParams() {
  try {
    if (typeof window === 'undefined') return;
    if (window.sessionStorage.getItem(STORAGE_KEY)) return;
    const params = new URLSearchParams(window.location.search);
    const utm = {};
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) utm[k] = v.slice(0, 100);
    });
    if (Object.keys(utm).length > 0) {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utm));
    }
  } catch {
    // sessionStorage indisponibil (private mode etc.) — atribuirea e best-effort
  }
}

/** UTM-urile capturate în sesiunea curentă ({} dacă nu există). */
export function getStoredUtm() {
  try {
    return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
}

/** True dacă sesiunea a început dintr-un link de presă. */
export function isPressVisit() {
  const utm = getStoredUtm();
  if (!utm.utm_source && !utm.utm_medium) return false;
  if ((utm.utm_medium || '').toLowerCase() === 'press') return true;
  return PRESS_SOURCES.includes((utm.utm_source || '').toLowerCase());
}
